/**
 * @generated SignedSource<<8bb7aa3e7e69a82f71d867aa4577d7ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type timelineLiveArticleLiveContent$data = ReadonlyArray<{
  readonly customTime: number | null | undefined;
  readonly entityUuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleTimelineLiveContent">;
  readonly " $fragmentType": "timelineLiveArticleLiveContent";
}>;
export type timelineLiveArticleLiveContent$key = ReadonlyArray<{
  readonly " $data"?: timelineLiveArticleLiveContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"timelineLiveArticleLiveContent">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "timelineLiveArticleLiveContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "itemLiveArticleTimelineLiveContent"
    }
  ],
  "type": "LiveContent",
  "abstractKey": null
};

(node as any).hash = "f22ccc63e0d80bcdda47cad0f3b45bce";

export default node;
